import { getTime } from "~/tools/date-time";
import type { Time } from "~/tools/date-time/time";

import type { TimeRange } from "../app/state/view/timeline/TimeRange";
import type { FullRelation } from "../common/openapi";
import { request } from "../generic/request";

import { type UseQueryOptions, type UseQueryResult, useQuery } from "./react-query";

export const useQueryFullRelationById = <TResult = FullRelation>(
	{
		relationId,
		timestamp,
		timeRange,
	}: {
		relationId: number;
		timestamp?: null | Time;
		timeRange?: null | TimeRange;
	},
	options?: UseQueryOptions<FullRelation, Error, TResult>,
): UseQueryResult<TResult, Error> =>
	useQuery(
		["relations", "full", relationId],
		() =>
			request<FullRelation>(`/api/relations/${relationId}`, {
				query: {
					topologyTime: getTime(timestamp),
				},
			}),
		{ ...options, timestamp, timeRange },
	);
